module.exports = __webpack_public_path__ + "img/gestao_membros_comites.5cb6ba53.png";